import lib from "zeta-dom";
const { CancellationRequest, cancelLock, lock, locked, notifyAsync, preventLeave, subscribeAsync } = lib.dom;
export { CancellationRequest, cancelLock, lock, locked, notifyAsync, preventLeave, subscribeAsync };